import Modal from "@/common/elements/Modal";
import { useMemo } from "react";
import { useState } from "react";
import FlagWarrantsDetails from "./FlagWarrantsDetails";
import FlagInformationDetails from "./FlagInformationDetails";
import FlagCivilPapersDetails from "./FlagCivilPapersDetails";
import FlagDangerDetails from "./FlagDangerDetails";
import FlagInJailDetails from "./FlagInJailDetails";
import FlagGangMemberDetails from "./FlagGangMemberDetails";
import FlagMedicalDetails from "./FlagMedicalDetails";
import FlagNotesDetails from "./FlagNotesDetails";
import FolderFullDetails from "./FolderFullDetails";

const JacketDetailsModal = ({ show, onHide,parentKey }) => {
  const [showInfoMoadl, setshowInfoMoadl] = useState(false);
  const clickAppointmentLog = () => {
    setshowInfoMoadl(true);
  };
  const sectionTabItems = useMemo(
    () => [
      {
        id: "1",
        label: "Information",
        key: "information",
        children: <FlagInformationDetails />,
      },
      {
        id: "2",
        label: "Warrants",
        key: "warrants",
        children: <FlagWarrantsDetails />,
      },
      {
        id: "3",
        label: "Civil Papers",
        key: "civil-papers",
        children: <FlagCivilPapersDetails />,
      },

      {
        id: "5",
        label: "DANGER",
        key: "danger",
        children: <FlagDangerDetails />,
      },
      {
        id: "6",
        label: "In Jail",
        key: "in-jail",
        children: <FlagInJailDetails />,
      },
      {
        id: "7",
        label: "Gang Member",
        key: "gang-member",
        children: <FlagGangMemberDetails />,
      },
      {
        id: "7",
        label: "Medical",
        key: "medical",
        children: <FlagMedicalDetails />,
      },
      {
        id: "7",
        label: "Notes",
        key: "notes",
        children: <FlagNotesDetails />,
      },
    ],
    []
  );

  const onModalHide = () => {
    onHide();
  };

  return (
    <>
      <Modal
        header="Folder Details"
        show={show}
        onHide={onModalHide}
        size="xxl"
        footerCloseAction
        footerCloseActionText="Close"
        footerActionsNeed={false}
      >
        <FolderFullDetails showFoldersList={false} parentKey={parentKey}/>
      </Modal>
    </>
  );
};

export default JacketDetailsModal;
